import { render, staticRenderFns } from "./NoPageDataTable.vue?vue&type=template&id=a4ea68e8&scoped=true&"
import script from "./NoPageDataTable.vue?vue&type=script&lang=js&"
export * from "./NoPageDataTable.vue?vue&type=script&lang=js&"
import style0 from "./NoPageDataTable.vue?vue&type=style&index=0&id=a4ea68e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ea68e8",
  null
  
)

export default component.exports